import { ApplicationConfig, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideTranslateService, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { provideTranslateHttpLoader, TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MdbNotificationService } from "mdb-angular-ui-kit/notification";
import { MdbModalService } from "mdb-angular-ui-kit/modal";
import { DatePipe, registerLocaleData } from "@angular/common";
import { AuthInterceptorService } from "./services/auth/auth-interceptor.service";
import localeDeAt from '@angular/common/locales/de-AT';
import { MdbPopconfirmService } from "mdb-angular-ui-kit/popconfirm";
import { provideAnimations } from '@angular/platform-browser/animations';

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader();
}

// Register the locale data
registerLocaleData(localeDeAt);

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(
      withInterceptorsFromDi()
    ),
    provideAnimations(),
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json'
      }),
      lang: 'de',
      fallbackLang: 'de',
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true
    },
    {
      provide: LOCALE_ID,
      useValue: "de-AT"
    },
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      })
    ),
    MdbNotificationService,
    MdbModalService,
    MdbPopconfirmService,
    DatePipe
  ]
};
